import { makeApiCall } from "../makeApiCall";
import { AdminService_URL } from "../Url";

export const pickerOrderActions = {
  FETCH_PICKER_ORDER_DATA_SUCCESS: "FETCH_PICKER_ORDER_DATA_SUCCESS",
  FETCH_PICKER_ORDER_DATA_FAILURE: "FETCH_PICKER_ORDER_DATA_FAILURE",
  FETCH_MED_MISSING_DETAILS_SUCCESS: "FETCH_MED_MISSING_DETAILS_SUCCESS",
  FETCH_MED_MISSING_DETAILS_FAILURE: "FETCH_MED_MISSING_DETAILS_FAILURE",
  SAVE_MISSING_MEDS_SUCCESS: "SAVE_MISSING_MEDS_SUCCESS",
  SAVE_MISSING_MEDS_FAILURE: "SAVE_MISSING_MEDS_FAILURE",
  CLEAR_PICKER_ORDER_DATA: "CLEAR_PICKER_ORDER_DATA",
  CONFIRM_MISSING_MED_DETAILS_SUCCESS: "CONFIRM_MISSING_MED_DETAILS_SUCCESS",
  CONFIRM_MISSING_MED_DETAILS_FAILURE: "CONFIRM_MISSING_MED_DETAILS_FAILURE",
};

export function clearPickerDetails() {
  return (dispatch) => {
    dispatch({
      type: pickerOrderActions.CLEAR_PICKER_ORDER_DATA,
      payload: "",
    });
  };
}

export function pickerOrderDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: pickerOrderActions.FETCH_PICKER_ORDER_DATA_SUCCESS,
      payload: props,
    });
  };
}

export function pickerOrderDetailsError(error) {
  return {
    type: pickerOrderActions.FETCH_PICKER_ORDER_DATA_FAILURE,
    payload: error,
  };
}

export function pickerOrderDetailsThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const getUrl = `${AdminService_URL}/getOrderDetailForPickerPwa?orderId=${props.orderId}&warehouseId=${props.warehouseId}`;
  return makeApiCall(
    getUrl,
    pickerOrderDetailsSuccess,
    pickerOrderDetailsError,
    "GET",
    null,
    reqHeader,
    props.history
  );
}

export function fetchMissingMedDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: pickerOrderActions.FETCH_MED_MISSING_DETAILS_SUCCESS,
      payload: props,
    });
  };
}

export function fetchMissingMedDetailsError(error) {
  return {
    type: pickerOrderActions.FETCH_MED_MISSING_DETAILS_FAILURE,
    payload: error,
  };
}

// get all missing medicine details for all order ids
export function fetchMissingMedDetailsThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const getUrl = props.orderId
    ? `${AdminService_URL}/fetchMissingMedicineDetails?warehouseId=${props.warehouseId}&orderId=${props.orderId}`
    : `${AdminService_URL}/fetchMissingMedicineDetails?warehouseId=${props.warehouseId}`;
  return makeApiCall(
    getUrl,
    fetchMissingMedDetailsSuccess,
    fetchMissingMedDetailsError,
    "GET",
    null,
    reqHeader,
    props.history
  );
}

export function saveMissingMedicineSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: pickerOrderActions.SAVE_MISSING_MEDS_SUCCESS,
      payload: props,
    });
  };
}

export function saveMissingMedicineError(error) {
  return {
    type: pickerOrderActions.SAVE_MISSING_MEDS_FAILURE,
    payload: error,
  };
}

// save missing meds details
export function saveMissingMedicineDetails(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const postUrl = `${AdminService_URL}/saveMissingMedicineDetails${
    props.isPicker === false ? `?isPicker=${props.isPicker}` : ""
  }`;
  return makeApiCall(
    postUrl,
    saveMissingMedicineSuccess,
    saveMissingMedicineError,
    "POST",
    props.missingMedicineDetailsList,
    reqHeader,
    props.history
  );
}

export function confirmMissingMedicineDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: pickerOrderActions.CONFIRM_MISSING_MED_DETAILS_SUCCESS,
      payload: props,
    });
  };
}

export function confirmMissingMedicineDetailsError(error) {
  return {
    type: pickerOrderActions.CONFIRM_MISSING_MED_DETAILS_FAILURE,
    payload: error,
  };
}

// confirm missing meds details
export function confirmMissingMedicineDetailsThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const postUrl = `${AdminService_URL}/confirmMissingMedicineDetails?warehouseId=${props.warehouseId}`;
  return makeApiCall(
    postUrl,
    confirmMissingMedicineDetailsSuccess,
    confirmMissingMedicineDetailsError,
    "POST",
    null,
    reqHeader,
    props.history
  );
}
